import { render, staticRenderFns } from "./Emails.vue?vue&type=template&id=3cd4666a&scoped=true"
import script from "./Emails.vue?vue&type=script&lang=ts"
export * from "./Emails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd4666a",
  null
  
)

export default component.exports